// materialimport { useTheme } from '@material-ui/core/styles'
import { Box, Grid, Button, Card, Stack, Typography, TextField, MenuItem, Checkbox, makeStyles, CircularProgress, AvatarGroup, Tooltip, Avatar, InputAdornment, TableContainer, Table, Paper, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles';
import { isAdminUser } from '../../../../utils/adminUserTypes';
import AddTask from '../../AddTask'
import { forwardRef, useEffect, useState } from 'react'
import { UserMoreMenu } from 'src/components/_dashboard/user/list';
import ConfirmationPopup from 'src/components/confirmationPopup';
import axios from 'axios';
import { BASE_URL, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import { KeyboardBackspaceOutlined, Login, Logout, Search, Visibility } from '@material-ui/icons';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,Slider as Sliderw, Slide } from '@mui/material';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import moment from 'moment';
import FinishedProductmenu from 'src/components/_dashboard/blog/FinishedProductmenu';
import { empty } from 'src/Helpers/Common';
import Modal from 'src/components/_dashboard/blog/ProjectModel';

const option = [
  // { id: 6, color:'error', value: 'In Active' },
  { id: 1, color:'primary', value: 'New' },
  { id: 2, color:'info', value: 'In Progress' },
  { id: 3, color:'success', value: 'Completed' },
  { id: 4, color:'error', value: 'Rejected' },
  { id: 7, colors:'info', value: 'In Queue'}
  // { id: 4, color:'warning', value: 'Hold' },
  // { id: 5, color:'primary', value: 'Active' },
 
  // { id: 6, color:'success', value: 'Approved by Dev team' },
  // { id: 7, color:'success', value: 'Approved by the client' },
  // { id: 8, color:'primary', value: 'Reopen' },
]
const colors = [
  '#5bc0de',
  '#5bc0de',
  '#0b78e6',
  '#5cb85c',
  '#c9302c',
  '#0275d8',
  '#5cb85c',
  // '#c9302c',
  '#0b78e6',
  '#5cb85c',
  '#5bc0de',
]

const useStyles = makeStyles((theme) => ({
  card: {
      borderRadius: theme.spacing(1),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative', 
  },
  delete:{
    m:2,
    display:'flex',
    justifyContent:'flex-end' 
  },
  media: {
      height: 0,
      paddingTop: '100%', 
      width: '100%',
      objectFit: 'fill', 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      left: theme.spacing(1),
      zIndex:999,
  },
  gridContainer: {
      height: '350px', 
      overflowY: 'auto', 
      '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.1)',
          borderRadius: '4px',
        },
  },
}));

function ProjectStatusPopup({ open, onClose, staffTimeLogData, handleClockInOut, autoClockoutTime }) {
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [timerId]);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        handleClockInOut();
      }, autoClockoutTime * 60 * 1000);

      setTimerId(timer);
    } else {
      if (timerId) {
        clearTimeout(timerId);
      }
    }
  }, [open]);
 
  return (
      <Dialog  onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(false);
        }
      }}>
          <DialogTitle>Are you still working on this project?</DialogTitle>
          <DialogContent>
              <DialogContentText sx={{mt:3}}>
                  Do you want to continue working on "{staffTimeLogData?.task_name}" in "{staffTimeLogData?.project_name}"?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button variant='contained' onClick={() => { clearTimeout(timerId); onClose(true); }}>
                  Yes
              </Button>
              <Button variant='outlined' onClick={() => { clearTimeout(timerId); onClose(false); }}>
                  No
              </Button>
          </DialogActions>
      </Dialog>
  );
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function DesignOrderSubTasks({ details, data, loading, setFetchData, projectMembers, taskId, projectId, setRefresh, refresh,currentTab, onProjectRefresh, designs }) {
  const triggerProjectRefresh = () => {
    if (typeof onProjectRefresh === 'function') {
      onProjectRefresh()
    }
  }
  console.log('data+++++++', data)
  console.log('details+++++++', details)
  console.log('designs+++++++', designs)
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar();
  const [singleData, setSingleData] = useState(null)
  const [add, setAdd] = useState(false)
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [isDelete,setIsDelete] = useState(false)
  const [isEdit,setIsEdit] = useState(false)
  const [deleteStates, setDeleteStates] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isSelectAll, setIsSelectAll] = useState(false)
  const [confirmAdditionalJObCost, setConfirmAdditionalJObCost] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')
  const [materialData, setMaterialData] = useState(null)
  const [staffTimeLog, setStaffTimeLog] = useState(null)
  const [openPopup, setOpenPopup] = useState(false);
  const [searchMaterial, setSearchMaterial] = useState('');
  const [qty, setQty] = useState(1);
  const [viewMaterialData, setViewMaterialData] = useState([]);
  const [viewMaterial, setViewMaterial] = useState(false);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const classes = useStyles();
  const [completeStatus, setCompleteStatus] = useState(1)
  const [checkedItems, setCheckedItems] = useState([]);
  const [popUpTime, setPopUpTime] = useState(0);
  const [autoClockoutTime, setAutoClockoutTime] = useState(0);
  const [openPopupComplete, setOpenPopupComplete] = useState(false)
  const user = JSON.parse(window.localStorage.getItem('user'))
  const[skillsandServices,setSkillsService]=useState([])
  const userId = user?.user_id
  const[view,setView]=useState(false)
  const [openService, setOpenService] = useState(false)
  const [subTaskMembers,setSubTaskMembers] = useState([])
  console.log('subTaskMembers..', subTaskMembers)
  const [clockInInputs, setClockInInputs] = useState([]);
  const [subTaskId, setSubTaskId] = useState(null);
  const [fromStatus, setFromStatus] = useState(false);
  const [loading2,setLoading2] = useState(false)
  const userType = user?.user_type
 console.log("##############details",details);
  const fetchClockSettings = async() => {
    try {
        const res = await axios.post(`${REST_API_END_POINT}settings/fetch-all-clock-settings`)
        if(res.data.status === 1){
            const settingsData = res.data.clocksettings
            settingsData?.map((item)=>{
              if(item?.id == 1){
                setPopUpTime(parseInt(item?.time))
              }else if(item?.id == 2){
                setAutoClockoutTime(parseInt(item?.time))
              }
            })
        }else{
          
            setPopUpTime(0)
            setAutoClockoutTime(0)
        }
    } catch (error) {
        console.log("Clock settings error : ",error)
        setPopUpTime(0)
        setAutoClockoutTime(0)
    }
  }
 
  useEffect(()=>{
    fetchClockSettings()
  },[])

  const handleClockinTime = (members,taskId,fromStatus=false)=>{
    try {
      setSubTaskMembers(members)
      setOpenService(true)
      setSubTaskId(taskId)
      setFromStatus(fromStatus)
    } catch (error) {
      console.log('error',error )
    }
  }

  const updateClockInInput = (staffId, data) => {
    setClockInInputs((prev) => {
      const exists = prev.find((item) => item.staff_id === staffId);
      if (exists) {
        return prev.map((item) =>
          item.staff_id === staffId ? { ...item, ...data } : item
        );
      } else {
        return [...prev, { staff_id: staffId, ...data }];
      }
    });
  };

  const getClockInPayload = () => {
    const now = moment().unix();
    const subtaskData = data?.find(item => item.id === subTaskId);
    const subtaskName = subtaskData?.name || 'N/A';
    
    return clockInInputs
      .filter((entry) => {
        const hasHour = entry.hour > 0;
        return hasHour;
      })
      .map((entry) => {
        const staffMember = subTaskMembers.find(member => 
          member.staff_id === entry.staff_id || 
          member.id === entry.staff_id || 
          member.userId === entry.userId ||
          member.user_id===entry.user_id
        );
        const staffName = staffMember?.name || staffMember?.staff_name || 'N/A';
        const userId = staffMember?.user_id || staffMember?.userId || entry.userId;
        
        return {
          ...entry,
          subtask_id: subTaskId,
          start_time: now - Math.round(entry.hour * 3600),
          end_time: now,
          staff_name: staffName,
          userId: userId,
          user_id: staffMember?.user_id || entry.user_id,
          subtask_name: subtaskName,
        };
      });
  };

  const isClockInDisabled = subTaskMembers.every((member) => {
    const entry = clockInInputs.find((e) => e.staff_id === member.staff_id);
    const hasHour = entry?.hour > 0;
    return !(hasHour);
  });

  const handleClose =()=>{
    setOpenService(false)
    setClockInInputs([])
    setSubTaskMembers([])
    setSubTaskId(null)
  }

  const handleConfirmAdditionalJobCost = async () => {
  try{
    let realQty = materialData?.balanceQty || (qty || 1)
    let values = [
      {
        productId: materialData.product_id || materialData.id,
        projectId: projectId,
        actual_quantity: materialData.actual_quantity || 0,
        actual_unit_cost: materialData.actual_unit_cost || 0,
        actual_total: materialData.actual_total || 0,

        // actual_quantity: project.unit_qty || 0,
        // actual_unit_cost: project.unit_cost || 0,
        // actual_total: project.actual_total_cost || 0,


        quantity: materialData?.balanceQty || (qty || 1),
        total: (materialData.unit_price * realQty) || (materialData.unit_cost * realQty),
        unitPrice: materialData.unit_price || materialData.unit_cost
      }
    ];  
    axios.post(`${REST_API_END_POINT}project/add-job-cost`, 
      { userId: user.user_id, values, projectId, recipe: 0, selectedServices:[], scanQr : true, taskId,qty }, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else if (response?.data?.message) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      } else {
        enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
      }
      setConfirmAdditionalJObCost(false);
      setConfirmMessage('');
      setSearchMaterial('');
      setRefresh(!refresh);
    }).catch((error) => {
      console.error(error);
      enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
    })
    setQty(1)
    }catch(error){
      console.log(error)
    }
  }
  console.log('datadatadata====',data)
  const handleDeleteClick = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: true,
    }));
  };

  const handleCancelDelete = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: false,
    }));
  };
  const valuetext = (value) => {
   
    return `${value}%`
  }
  const updateStatus=(event,value)=>{
    
    let values={}
    let user=JSON.parse(window.localStorage.getItem('user'))
    values.completion=event.target.value
     values.projectId=projectId
    values.added_by=user.user_id
    values.taskId=value
    values.task=taskId
    
    if(event.target.value && values.taskId){
      axios.post(`${REST_API_END_POINT}project/update-project-sub-task-progress`,{ ...values },{
        headers: {
          'Content-Type': 'application/json',
        },
        // headers: { 'Content-Type': 'multipart/form-data' }
      })
    }
    
  }
  const handleDeleteSubTask = (id)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/delete-project-sub-task`,{ id: Number(id),taskId,projectId,status: 0 },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4){
          enqueueSnackbar(response.data.message, { variant: 'success' });
          setRefresh(!refresh)
          setFetchData(true)
          triggerProjectRefresh()
        }else if(response.data.status === 5){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        handleCancelDelete(id)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  const handleFetchSubTask = (id)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/view-project-sub-task`,{ id: Number(id) },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          // enqueueSnackbar(response.data.message, { variant: 'success' });
          setSingleData(response.data.result[0])
          setIsEdit(true)
         
        }else if(response.data.status === 0){
          // enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        handleCancelDelete(id)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleFetchSubTaskView = (id,view=true)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/view-project-design-order-sub-task`,{ id: Number(id) },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){ 
          // enqueueSnackbar(response.data.message, { variant: 'success' });
        
          setSingleData(response.data.result[0])

          setIsEdit(true)
          setView(view)
        }else if(response.data.status === 0){
          // enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        handleCancelDelete(id)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleUpdateStatus = (id,status,skipModal=false)=>{
    try {
      if(designs?.length === 0 && status===3){
        enqueueSnackbar('Please add at least one design before completing', { variant: 'error' });
        return;
      }
      if(status===3){
        const subtaskData = data?.find(item => item.id === id);
        if(subtaskData?.design_order_job_status===3){
          const updateData = {
            design_order_job_status: 2,
          }
        }
      }
      if(isLoggedIn){
        enqueueSnackbar('Please clockout', { variant: 'error' });
      }else{
        if (status === 3 && !skipModal) {
          const subtaskData = data?.find(item => item.id === id);
          if (subtaskData?.teamMembers && subtaskData.teamMembers.length > 0) {
            handleClockinTime(subtaskData.teamMembers, id, true);
            return;
          }
        }
        const  user  = JSON.parse(window.localStorage.getItem('user'))
        axios.post(`${REST_API_END_POINT}project/update-project-design-order-sub-task-status`,
          { subTaskId: Number(id),task:Number(taskId),projectId,status,userId:user.user_id },{
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if(response.data.status === 1){
            // if(response.data.readyForInstallation){
            //   if(details?.project_category == 14){
            //     setCompleteStatus(1);
            //     convertJObToInstallation(user.user_id)
            //   }else{
                //  setOpenPopupComplete(true)
            //   }
            // }else{
              enqueueSnackbar(response.data.message, { variant: 'success' });
            // }
            // setSingleData(response.data.result[0])
            setFetchData(true)
            setRefresh(!refresh)
            triggerProjectRefresh()
          }else if(response.data.status === 0){
            // enqueueSnackbar(response.data.message, { variant: 'error' });
          }
          // setIsDelete(false)
        }).catch((error) => {
          console.error(error);
        })
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const convertJObToInstallation = async(userId)=>{
    const res = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,
      { selectedIds: Number(projectId), userId: userId,completeStatus:Number(completeStatus) })
      if(res.data.status===1) {
        setOpenPopupComplete(false);
        enqueueSnackbar(`${Number(completeStatus) === 1
          ? 'Moved To Installs'
          : Number(completeStatus) === 2
          ? 'Moved To Pickup'
          : 'Moved To Shipping'} Successfully`, { variant: 'success' });
      }else{
        enqueueSnackbar("Not Moved To Installation", { variant: 'error' });
      }
  }

  const handleUpdateAllStatus = (status) => {
    try {
      if(isLoggedIn){
        enqueueSnackbar('Please clockout', { variant: 'error' });
      }else{
        const user = JSON.parse(window.localStorage.getItem('user'))
        let resultArray = []
        checkedItems?.map(async(id)=>{
          const response = await axios.post(`${REST_API_END_POINT}project/update-project-sub-task-status`,{ taskId: Number(id),task:Number(taskId),projectId,status,userId:user.user_id },{
            headers: {
              'Content-Type': 'application/json',
            },
          })
          if(response.data.status === 1){
            resultArray.push(response.data.status);
            // if(response.data.readyForInstallation){
            //   if(details?.project_category == 14){
            //     setCompleteStatus(1);
            //     convertJObToInstallation(user.user_id)
            //   }else{
               setOpenPopupComplete(true)
            //   }
            // }
          }
        })
        enqueueSnackbar("Status updated successfully for all subtasks", { variant: 'success' });
        setFetchData(true);
        setRefresh(!refresh)
        triggerProjectRefresh()
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleCheckboxChange = (id) => {
    setCheckedItems((prevState) => {
      const isPresent = prevState.includes(id);
      const updatedState = isPresent
        ? prevState.filter((item) => item !== id)
        : [...prevState, id];
      return updatedState;
    });   
  };

  const handleSelectAll = () => {
    if(isSelectAll){
      setIsSelectAll(false);
      setCheckedItems([]);
    }else{
      const allIds = data?.map((post) => String(post.id)) || [];
      setCheckedItems(allIds);
    }
    setIsSelectAll(!isSelectAll);
  }

  const fetchTimeLogData = async () => {
    try{
      const res = await axios.post(`${REST_API_END_POINT}project-task/fetch-clockedIn-design-order-staff-task-timelog`,
      {projectId:projectId,taskId:taskId,userId:userId})
      if(res.data.status===1){
        const staffTimeLogData = res.data.result[0]
        let taskIds = staffTimeLogData?.sub_task_id
        taskIds = taskIds?.toString();
        const taskArray = taskIds?.split(",");
        setCheckedItems(taskArray)
        setStaffTimeLog(staffTimeLogData)
        if(staffTimeLogData.end_time === null){
          setIsLoggedIn(true)
        }else{
          setIsLoggedIn(false)
        }
      }else{
        setStaffTimeLog(null)
        setIsLoggedIn(false)
        setCheckedItems([])
      }
    }catch(error){
      console.log('Error fetching : ',error);
    }
  }


  useEffect(()=>{
    fetchTimeLogData()
  },[isLoggedIn])

  useEffect(() => {
    if(isLoggedIn){
      const intervalId = setInterval(() => {
          setOpenPopup(true);
      }, popUpTime * 60 * 1000);

      return () => {
          clearInterval(intervalId);
      };
    }
}, [isLoggedIn]);

const handleClockInOut = async()=>{
  try {
    if(checkedItems?.length > 0){
      let res = '';
      const now = Math.round(moment().valueOf() / 1000);
      if(isLoggedIn){
        const timeLogId = staffTimeLog?.id
        const startTime = staffTimeLog?.start_time
        const staffId =  staffTimeLog?.staff_id
        const staffHourlyRate = staffTimeLog?.staff_hourly_rate || 20
        res = await axios.post(`${REST_API_END_POINT}project-task/update-design-order-staff-task-timelog`,{checkedItems, projectId, userId, timeLogId,taskId,startTime, now, staffId, staffHourlyRate})
        setFetchData(true)
      }else{
        res = await axios.post(`${REST_API_END_POINT}project-task/add-design-order-staff-task-timelog`,{checkedItems, projectId, userId,taskId,now})
        // setFetchData(true)
      }
      setIsLoggedIn(!isLoggedIn)
      setOpenPopup(false);
      setElapsedTime(0)
      if(res.data.status===1){
       
        if(res.data.result === 'add'){
          enqueueSnackbar('Clocked In successfully', { variant: 'success' });
        }else if(res.data.result === 'update'){
          enqueueSnackbar('Clocked Out successfully', { variant: 'success' });
        }
      }else{
        console.log('handleClockInOut res : ',res.data);
      }
    }else{
      enqueueSnackbar("Please select atleast one sub task",{variant:'error'})
    }
  }catch(error){
    console.log('HandleClockInOut error : ',error);
  }
}

const handleClockInOutDialog = async() => {
  setLoading2(true)
  const now = moment().unix();
  const memberClockins = getClockInPayload();

  if (memberClockins.length === 0) {
    enqueueSnackbar("Please enter time for at least one member", { variant: 'error' });
    setLoading2(false)
    return;
  }

  const payload = {
    projectId,
    taskId,
    userId,
    isDriver: false,
    memberClockins,
    checkedItems: [String(subTaskId)],
    now
  };

  try {
    const res = await axios.post(
      `${REST_API_END_POINT}project-task/update-design-order-staff-task-timelog`,
      payload
    );
    if (res.data.status === 1) {
      enqueueSnackbar('Time log added successfully ', { variant: 'success' });
      setClockInInputs([]);      
      setElapsedTime(0);    
      setIsLoggedIn(false);  
      setFetchData(true);
    } else {
      enqueueSnackbar("Clock-in failed", { variant: 'error' });
    }
    setOpenService(false)
    if(fromStatus){
      handleUpdateStatus(subTaskId,3,true);
    }
    handleClose();
    setLoading2(false)
  } catch (error) {
    console.error('API Error:', error);
    enqueueSnackbar("Clock-in failed", { variant: 'error' });
    handleClose(); 
    setLoading2(false)
  }
};

const handleClosePopup = (continueWorking) => {
  setOpenPopup(false);
  if (!continueWorking) {
    handleClockInOut();
  }
};

useEffect(() => {
  if(staffTimeLog){
    const interval = setInterval(() => {
      const now = Math.round(moment().valueOf() / 1000);
      const difference = now - staffTimeLog?.start_time;

      setElapsedTime(difference);
    }, 1000);

    return () => clearInterval(interval);
  }
}, [staffTimeLog]);

  const hours = String(Math.floor(elapsedTime / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((elapsedTime % 3600) / 60)).padStart(2, '0');
  const seconds = String(elapsedTime % 60).padStart(2, '0');

  const handleTypographyClick = () => {
   
    setIsEdit(true);
  };
  const fetchAllSkills = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}settings/get-all-settings`, {userId:user.user_id, userType: user.user_type})
      let data = response.data.results.services;
      setSkillsService(data)     
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(()=>{
    fetchAllSkills()
  },[isEdit])

  const getMostCommonStatus = () => {
    const statusCount = {};
    
    data?.forEach((post) => {
      const status = post?.status;
      if (status) {
        statusCount[status] = (statusCount[status] || 0) + 1;
      }
    });
  
    const mostCommonStatus = Object.keys(statusCount).reduce((a, b) => 
      statusCount[a] > statusCount[b] ? a : b
    );
    return mostCommonStatus;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
          {(data?.length > 0) && <Stack justifyContent='space-between' alignItems='center' flexDirection='row'>
            <Stack justifyContent='flex-start' alignItems='center' flexDirection='row'>
              <Typography  variant='subtitle1'>{(checkedItems?.length > 0) && checkedItems?.length+' selected' }</Typography>
            </Stack>
            {(user.user_type !== 3  && currentTab!="Rejected" && currentTab!="Hold" && details?.hold == 0 && details?.design_order_job_status != 4 ) &&
            <Stack justifyContent='flex-end' alignItems='center' flexDirection='row'>
              <Card>
                <Stack justifyContent='flex-end' alignItems='center' flexDirection='row' sx={{m:2}}>
                  <Stack justifyContent='center' alignItems='center' flexDirection='column' sx={{mr:2}}>
                    <Typography variant="h6" sx={{textAlign: 'center',color:theme.palette.secondary}}>
                    {"Date"} </Typography>
                    <Typography variant="h5" sx={{textAlign: 'center',color:theme.palette.secondary}}>
                    {moment().format('MM/DD/YYYY')}</Typography>
                  </Stack>
                  <Stack justifyContent='center' alignItems='center' flexDirection='column'>
                  <Typography variant="h6" sx={{textAlign: 'center',color:'#fc8c03'}}>
                  {"Work Time"} </Typography>
                  {isLoggedIn ? 
                    // (elapsedTime!==0) ?
                      <Typography variant="h4" sx={{textAlign: 'center',color:'#fc8c03'}}>
                      {hours+':'+minutes+':'+seconds}</Typography> 
                    // :
                    // <Stack sx={{mr:2,textAlign: 'center',mb: 2}}>
                    //   <CircularProgress color="warning" variant="indeterminate" size='20px' />
                    // </Stack>
                  : <Typography variant="h4" sx={{textAlign: 'center',color:'#fc8c03'}}>
                      {'00:00:00'}</Typography>  }
                  </Stack>
                </Stack>
              </Card>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isSelectAll}
                  onClick={()=>{handleClockInOut()}}
                  sx={{ mb: 2,ml:2 }}
                  startIcon={
                    <Stack>
                      {isLoggedIn ? <Logout /> : <Login />}
                    </Stack>
                  }
                >
                  {isLoggedIn ? "Clock Out" : "Clock In"}
                </Button>
            </Stack>}
          </Stack>}
          { (user.user_type !== 3 && currentTab!="Installations" && currentTab!="Completed" && currentTab!="Rejected" && currentTab!="Hold" && details?.hold == 0) &&
          <Box width={'100%'} display={'flex'} justifyContent={ (currentTab == "Pre-Production") ? 'space-between' : 'flex-end'} mb={2}>
            {(currentTab == "Pre-Production" && data?.length > 0) &&
            <Box display={'flex'} >
              <Checkbox sx={{cursor:'pointer'}}
                disabled={isLoggedIn ? true : false}
                checked={isSelectAll}
                onChange={() => {(isLoggedIn) ? null : handleSelectAll()}}
                color="primary"
              />
              <Typography sx={{mt:1}}>Select All</Typography>
            </Box>
            }
            {isSelectAll ?
              <TextField
                select
                size="small"
                value={option?.find(opt=>opt.id==getMostCommonStatus())?.value || ''}
                sx={{
                  minWidth: { lg: '50%', md: '40%', sm: '30%' },
                  // height: '30px !important',
                  background: colors[getMostCommonStatus()],
                  color:'blue',
                  borderRadius: 1,
                  border: 'none',
                  '&:hover': {
                    // transform: 'scale(1.02)',
                    border: 'none',
                  },
                }}
              >
                {option.map((optio) => (
                  <MenuItem
                    disabled={(user.user_type == 3 &&  currentTab==="Installations")? true : false}
                    onClick={() => {
                      handleUpdateAllStatus(optio.id)
                    }}
                    key={optio.value}
                    value={optio.value}
                  >
                    {optio.value}
                  </MenuItem>
                ))}
              </TextField>
            : ''
              // <Button onClick={() => {
              // setAdd(true);
              // }} 
              // variant="outlined"
              // disabled={isSelectAll}
              // startIcon={<Icon icon={plusFill} />}>Add Subtask</Button>
            }
          </Box>}
        {loading ? (
        <Box
          width={'100%'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          py={15}
        >
          <CircularProgress color="primary" variant="indeterminate" />
        </Box>
        ) : data?.length ? data.map((post, index) => {
          return(
        // <Grid key={index} item xs={12} sm={6}>
          <Card key={index}
            sx={{
              minWidth: 275,
              mb: 2,
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
              },
              backgroundColor: checkedItems.includes(String(post.id)) ? theme.palette.divider : null,
            }}
          >
            {/* <Box className={classes.checkboxContainer}>
              <Checkbox sx={{cursor:'pointer'}}
                checked={checkedItems?.includes(String(post?.id)) ? true : false}
                onChange={() => {isLoggedIn ? null : handleCheckboxChange(String(post.id))}}
                color="primary"
              />
            </Box> */}
            
            <Box sx={{ px: 2, py: 1, textAlign: 'center', justifyContent: 'center' }}>
            {(user.user_type !== 3 && currentTab!="Completed" && currentTab!="Rejected" && currentTab!="Hold" && details?.hold == 0 && details?.design_order_job_status != 3 && details?.design_order_job_status != 4) &&
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Checkbox sx={{cursor:'pointer'}}
                  checked={checkedItems?.includes(String(post?.id)) ? true : false}
                  onChange={() => {(isLoggedIn || post.status==3) ? null : handleCheckboxChange(String(post.id))}}
                  color="primary"
                />
              {/* {isSelectAll ? null :
               <UserMoreMenu
               onEdit={()=>{
                if(isLoggedIn){
                  enqueueSnackbar('Please clockout to make changes', { variant: 'error' });
                }else{
                  handleFetchSubTask(post.id)
                }
              }}
               onDelete={()=>{
                if(isLoggedIn){
                  enqueueSnackbar('Please clockout to delete the subtask', { variant: 'error' });
                }else{
                  handleDeleteClick(post.id)
                }}}
               />} */}
              </Stack>}
            </Box>
            <Box sx={{ px: 2,pb: 3, justifyContent: 'space-between' }}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Typography variant="h6" align="center" sx={{cursor:'pointer'}}
                  onClick={()=>handleFetchSubTaskView(post.id)}>
                  {post.name}
                </Typography>
                {/* <Stack>
                <Typography
                    variant="overline"
                    sx={{ mt: 3, display: 'block', color: 'text.secondary' }}
                  >
                    Description
                  </Typography>
                <Typography variant="body" align="center">
                  {post.description}
                </Typography>
                </Stack> */}
                {/* {(currentTab!="Installations" && currentTab!="Completed" && currentTab!="Hold") && */}
                <Typography variant="body" align="center">
                  {post?.total_hours ? 'Total Hours : '+post?.total_hours : 'Total Hours : 00:00:00'}
                </Typography>
                {/* } */}
               {/* {(currentTab!="Installations" && currentTab!="Completed" && currentTab!="Hold") &&  */}
                <TextField
                    select
                    // disabled={((checkedItems?.includes(String(post?.id)) || isSelectAll) || (user.user_type == 3 || details?.design_order_job_status == 3 || details?.hold == 1)) ? true : false}
                    disabled={((checkedItems?.includes(String(post?.id)) || isSelectAll) || (user.user_type == 3 || (details?.design_order_job_status == 3 && details?.status == 3) || details?.design_order_job_status == 4 || details?.hold == 1)) ? true : false}
                    size="small"
                    value={option.find(opt=>opt.id===post.status)?.value || ''}
                    sx={{
                      minWidth: { lg: '50%', md: '40%', sm: '30%' },
                      // height: '30px !important',
                      background: colors[post.status],
                      color:'blue',
                      borderRadius: 1,
                      border: 'none',
                      '&:hover': {
                        // transform: 'scale(1.02)',
                        border: 'none',
                      },
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'white !important',  // Makes the text white
                        WebkitTextFillColor: 'white !important', // Ensures white color is applied
                      },
                    }}
                  >
                {option
  .filter(optio => {
    // Show "In Queue" (id: 7) only if design_order_job_status is 7
    if (optio.id === 7) {
      return details?.design_order_job_status === 7;
    }
    return true; // show all other options
  })
  .map(optio => (
    <MenuItem
      key={optio.value}
      value={optio.value}
      disabled={
        user.user_type === 3 ||
        details?.design_order_job_status === 4 ||
        (details?.design_order_job_status === 3 && details?.status === 3)
      }
      onClick={() => handleUpdateStatus(post.id, optio.id)}
    >
      {optio.value}
    </MenuItem>
  ))}
                </TextField>
                {/* } */}
              </Stack>
            </Box>
           {/* {(currentTab!="Installations" && currentTab!="Completed" && currentTab!="Hold") && <Box sx={{ marginLeft: 2, marginRight: 2 }}>
                  <Typography
                    variant="overline"
                    sx={{ mt: 3,display: 'block', color: 'text.secondary' }}
                  >
                    Completion
                  </Typography>
                
                  <Sliderw
                    aria-label="Percentage"
                    defaultValue={post.complete}
                    getAriaValueText={valuetext}
                    onChange={(event, value) => updateStatus(event, post.id)}
                    valueLabelDisplay="auto"
                    disabled={(user.user_type == 3 && currentTab=="Installations") ? true : false}
                    //  step={10}
                    marks
                    min={0}
                    max={100}
                  />
            </Box>} */}
            <Box sx={{ display: 'flex',justifyContent:'space-between', alignItems: 'center', p: 2, }}>    
            {/* {post.status===3 && (
            <Stack
                direction={'row'}
                justifyContent={'flex-end'}
                alignItems={'center'}
              >
                <FinishedProductmenu 
                url={`${BASE_URL}view-sub-task/`}
                id={post.id}
                 useIcon={true}/>
                </Stack>
            )} */}
             <Stack>    
              <Typography variant="subtitle2">
                   Job Members
                    </Typography>             
                    <AvatarGroup max={4}>
                     {post.teamMembers?.map((row)=>( 
                        <Tooltip key={row.id} title={row.name}>             
                      <Avatar src={row.profile_pic} alt={row.name} />
                      </Tooltip>                   
                     ))}
                    </AvatarGroup>
                  </Stack>
                  {
                    (post?.teamMembers.length > 0 && ( currentTab!="Hold" && currentTab!="Rejected")) ?
                    <Button variant='outlined' onClick={()=>handleClockinTime(post?.teamMembers,post.id)}>Work Time</Button>
                  :''
                  }
            </Box>
            <ConfirmationPopup open={deleteStates[post.id]} handleClick={()=>handleDeleteSubTask(post.id)} message={'Want to Delete This SubTask'} handleClose={()=>handleCancelDelete(post.id)}/>
          </Card>
          )
        }) :
        <Box
          width={'100%'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          py={15}
        >
          No subtasks found 
        </Box>}
      </Grid>
      <ConfirmationPopup open={confirmAdditionalJObCost} handleClick={()=>handleConfirmAdditionalJobCost()} message={confirmMessage} handleClose={()=>{setConfirmAdditionalJObCost(false);setConfirmMessage('');setSearchMaterial('')}}/>
      <AddTask designOrder={true} title={isEdit ? view?'View SubTask':'Edit SubTask' : 'Add SubTask'} data={singleData} setData={setSingleData} setFetchData={setFetchData} projectMembers={projectMembers} taskId={taskId} add={add || isEdit} setAdd={isEdit ? setIsEdit : setAdd} projectId={projectId} view={view} setView={setView} skillsandServices={skillsandServices} />
      {/* <ProjectStatusPopup open={openPopup} onClose={handleClosePopup} staffTimeLogData={staffTimeLog} handleClockInOut={handleClockInOut} autoClockoutTime={autoClockoutTime} /> */}
      <Modal
      open={viewMaterial ? true : false}
      handleClose={() => {
        setViewMaterialData([]);
        setViewMaterial(false);
      }}
      modalTitle={'Materials added'}
    >
      {loadingMaterials ?
      (
        <CircularProgress color="primary" variant="indeterminate" />
      ) : (
        viewMaterialData?.length > 0 ?
        <TableContainer component={Paper}>
          <Table>
              <TableHead>
                  <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>Barcode</TableCell>
                      <TableCell>Product Name</TableCell>
                      <TableCell>Unit Cost</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Total</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                  {viewMaterialData?.map((material, index) => (
                      <TableRow key={material.id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{material.barcode}</TableCell>
                          <TableCell>{material.productName}</TableCell>
                          <TableCell>{material.unit_price}</TableCell>
                          <TableCell>{material.quantity}</TableCell>
                        <TableCell>{parseFloat(material.unit_price * material.quantity).toFixed(2)}</TableCell>
                          {/* <TableCell>{material.total}</TableCell> */}
                      </TableRow>
                  ))}
              </TableBody>
          </Table>
        </TableContainer>
        :
        <Typography>No materials added</Typography>
      )}
    </Modal>
    <ConfirmationPopup
      isComplete={true}
      setCompleteStatus={setCompleteStatus}
        open={openPopupComplete}
        handleClick={() => {
        //   convertJObToInstallation(user.user_id)
        }}
        handleClose={() => {
          setOpenPopupComplete(!openPopupComplete)
        }}
        // message={`All tasks and subtasks have been moved to the ${status?.value} state`}
      />
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        TransitionComponent={Transition}
        transitionDuration={500}
        open={openService}
        PaperProps={{
          sx: {
            width: { xs: '90%', sm: '60%' , md:'70%' },
            p: 2,
            borderRadius: 2
          }
        }}
      >
        <DialogContent
          sx={{
            mt: 1,
            px: 2,
            overflowY: 'auto',
            overflowX: 'auto',
            scrollbarWidth: 'thin', 
            '&::-webkit-scrollbar': {
              width: '0.75rem',
            },
            '&::-webkit-scrollbar-track': {
              boxShadow: 'inset 0 0 6px rgba(110, 108, 108, 0.32)',
              webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(110, 108, 108, 0.32)',
              borderRadius: '4px',
            },
            maxHeight: 500,
          }}
        >
          <Table size="small" sx={{ minWidth: 500 }}>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ width: '30%', py: 1 }}>
                  <strong>Member</strong>
                </TableCell>
                <TableCell align="center" sx={{ width: '25%', py: 1 }}>
                  <Box>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Time
                    </Typography>
                    <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                      (HH:MM)
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
              (isAdminUser (userType) || userType === 8
                ? subTaskMembers
                : subTaskMembers.filter((item) => item.user_id === userId)
                ).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    No job members available
                  </TableCell>
                </TableRow>
                ) : 
              (isAdminUser (userType) || userType === 8
                  ? subTaskMembers
                  : subTaskMembers.filter((item) => item.user_id === userId)
                ).map((item) => (
                <TableRow key={item.id} sx={{mt:2, height: 44 }}>
                  <TableCell align="center">{item.name}</TableCell>

                  <TableCell>
                    <Stack direction="row" spacing={1} justifyContent="center">
                      <TextField
                        name="hours"  
                        label="Hours"
                        placeholder="01"
                        size="small"
                        sx={{ width: 80 }}
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
                          ];

                          if (
                            !allowedKeys.includes(e.key) &&
                            !(e.key.length === 1 && allowedKeys.includes(e.key))
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const h = parseInt(e.target.value || '0', 10);
                          const m = parseInt(
                            e.target.closest('tr').querySelector('input[name="minutes"]')?.value || '0',
                            10
                          );

                          const totalMinutes = h * 60 + m;
                          const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                          updateClockInInput(item.staff_id, {
                            hour: decimal,
                            hourly_rate: item.hourly_rate,
                            userId: item.user_id
                          });
                        }}
                      />

                      <TextField
                        label="Minutes"
                        name="minutes"
                        placeholder="30"
                        size="small"
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
                          ];

                          if (
                            !allowedKeys.includes(e.key) &&
                            !(e.key.length === 1 && allowedKeys.includes(e.key))
                          ) {
                            e.preventDefault();
                          }
                        }}
                        sx={{ width: 80 }}
                        inputProps={{ min: 0, max: 60 }}
                        onInput={(e) => {
                          const value = parseInt(e.target.value || '0', 10);
                          if (value > 60) {
                            e.target.value = 60;
                          } else if (value < 0) {
                            e.target.value = 0;
                          }
                        }}
                        onChange={(e) => {
                          let m = parseInt(e.target.value || '0', 10);
                          let h = parseInt(
                            e.target.closest('tr').querySelector('input[name="hours"]')?.value || '0',
                            10
                          );

                          const totalMinutes = h * 60 + m;
                          const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                          updateClockInInput(item.staff_id, {
                            hour: decimal,
                            hourly_rate: item.hourly_rate,
                            userId: item.user_id
                          });
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </DialogContent>

        <Stack direction="row" justifyContent="flex-end" spacing={2} px={3} mt={1} pb={2}>
          <Button
            onClick={() => {
              handleClose();
              enqueueSnackbar('Operation was cancelled', { variant: 'error' });
            }}
            sx={{
              background: '#BB2525',
              color: '#fff',
              '&:hover': {
                background: '#FF8F8F',
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              handleClockInOutDialog()
            }
            }
            disabled={isClockInDisabled}
          >
            {loading2 ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Clock In'
            )}
          </Button>
        </Stack>
      </Dialog>
    </Grid>
  )
}
